import { type Control, Controller } from "react-hook-form";

import { INTEGRATIONS_MAP } from "features/integrations/constants";
import useIntegrationSettings from "features/integrations/datahooks/useIntegrationSettings";
import type { OutreachSourceType } from "features/integrations/types";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import FormField from "common/components/ui/FormField";
import SelectButton from "common/components/ui/SelectButton";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import type { CrmSourceSchemaType } from "../../../schemas";

const CRM_OPTIONS: OutreachSourceType[] = [
  "instantly",
  "smartlead",
  "emailbison",
];

export default function SourceTypeFormField({
  control,
}: {
  control: Control<CrmSourceSchemaType>;
}) {
  const isDesktop = useTwBreakpoint("lg");

  const { integrationSettings, isLoadingIntegrationSettings } =
    useIntegrationSettings();

  return (
    <Controller
      control={control}
      name="sourceType"
      render={({ field, fieldState }) => (
        <FormField
          label="Select CRM"
          htmlFor="crm-select"
          error={fieldState.error?.message}
        >
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <SelectButton
                size={isDesktop ? "md" : "lg"}
                hasSelection={!!field.value}
                isLoading={isLoadingIntegrationSettings}
                hasError={!!fieldState.error}
              >
                {field.value
                  ? INTEGRATIONS_MAP[field.value].title
                  : "Select a CRM"}
              </SelectButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-[var(--radix-popper-anchor-width)]">
              <DropdownMenuList>
                {CRM_OPTIONS.map((key) => {
                  const isDisabled = !integrationSettings?.[key];
                  const { title, simpleIcon: Icon } = INTEGRATIONS_MAP[key];

                  return (
                    <DropdownMenuItem
                      key={key}
                      disabled={isDisabled}
                      onSelect={() => field.onChange(key)}
                    >
                      <Icon />
                      {title}
                    </DropdownMenuItem>
                  );
                })}
              </DropdownMenuList>
            </DropdownMenuContent>
          </DropdownMenu>
        </FormField>
      )}
    />
  );
}
